import classNames from 'classnames';

export default function Level(props: {
    children?: any,
    className?: string,
}) {
    let className = props.className ?? '';

    const classes = classNames('level', {
        [className]: className.length
    });

    return (
        <div className={classes}>
            {props.children}
        </div>
    );
}
